@if (dataLoading()) {<app-progress></app-progress>};
<div class="page-content">
    <div class="container-fluid">

        <!-- Page Title & Breadcrumb -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">{{ action().MenuTitle }}</h4>
                    <div class="page-title-right">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item">
                                <a routerLink="/admin/admin-dashboard">Dashboard</a>
                            </li>
                            <li class="breadcrumb-item active">{{ action().ParentMenuTitle }}</li>
                            <li class="breadcrumb-item">{{ action().MenuTitle }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <span>Set Hotel Rate</span>
                        <!-- @if (HotelRate.HotelId && RoomTypeList().length === 0) { -->
                        @if (showRoomTypeError()) {
                        <span class=" text-danger text-center text-muted error fade-message">
                            <span class="text-danger"> *No room type is available for this hotel. Please add room type
                            </span>
                        </span>
                        }
                        <!-- (HotelRate.HotelId && RoomTypeList().length > 0) -->
                        @if (showRoomTypeErrorList()) {
                        <span class="text-success text-center fade-message errors">
                            Room type available
                        </span>
                        }
                        <br>
                        <form #formHotelRate="ngForm">
                            <div class="row d-flex align-items-center mt-2">










                                <!-- Destination -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>Destination</mat-label>
                                    <mat-select name="SelectedDestinationId" [(ngModel)]="SelectedDestinationId"
                                        (ngModelChange)="onFormDestinationChange()" required>
                                        @for (dest of DestinationList(); track dest.DestinationId) {
                                        <mat-option [value]="dest.DestinationId">{{ dest.DestinationName }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <!-- Location -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>Location</mat-label>
                                    <mat-select name="SelectedLocationId" [(ngModel)]="SelectedLocationId"
                                        (ngModelChange)="onFormLocationChange()" required>
                                        @for (loc of LocationList(); track loc.LocationId) {
                                        <mat-option [value]="loc.LocationId">{{ loc.LocationName }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <!-- Select Hotel — change HotelList() to FilteredHotelList() -->
                                <mat-form-field appearance="outline" class="col-sm-4">
                                    <mat-label>Select Hotel</mat-label>
                                    <mat-select #HotelId="ngModel" name="HotelId" [(ngModel)]="HotelRate.HotelId"
                                        (ngModelChange)="onHotelChange()" required>
                                        @for (dest of FilteredHotelList(); track dest.HotelId) { <!-- 👈 changed -->
                                        <mat-option [value]="dest.HotelId">{{ dest.HotelName }}</mat-option>
                                        }
                                    </mat-select>
                                    @if ((HotelId.dirty || HotelId.touched) || (HotelId.invalid && isSubmitted)) {
                                    <mat-error>Hotel is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>









                                <!-- Select Hotel -->
                                <!-- <mat-form-field appearance="outline" class="col-sm-3">
                                    <mat-label>Select Hotel</mat-label>
                                    <mat-select #HotelId="ngModel" name="HotelId" [(ngModel)]="HotelRate.HotelId"
                                        (ngModelChange)="onHotelChange()" required>
                                        @for (dest of HotelList(); track dest.HotelId) {
                                        <mat-option [value]="dest.HotelId">{{ dest.HotelName }}</mat-option>
                                        }
                                    </mat-select>
                                    @if ((HotelId.dirty || HotelId.touched) || (HotelId.invalid && isSubmitted)) {
                                    <mat-error>Hotel is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field> -->

                                <!-- Hotel Category -->
                                <mat-form-field appearance="outline" class="col-lg-2">
                                    <mat-label>Hotel Category</mat-label>
                                    <input matInput name="HotelCategoryName" [(ngModel)]="HotelRate.HotelCategoryName"
                                        readonly="true" />
                                </mat-form-field>



                                <!-- Room Type -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>Room Type</mat-label>
                                    <mat-select #RoomTypeId="ngModel" name="RoomTypeId"
                                        [(ngModel)]="HotelRate.RoomTypeId" required>
                                        @for (room of RoomTypeList(); track room.RoomTypeId) {
                                        <mat-option [value]="room.RoomTypeId">{{ room.RoomTypeName }}</mat-option>
                                        }
                                    </mat-select>
                                    @if ((RoomTypeId.dirty || RoomTypeId.touched) || (RoomTypeId.invalid &&
                                    isSubmitted)) {
                                    <mat-error>Room Type is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <!-- From Date -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>From Date</mat-label>
                                    <input matInput [matDatepicker]="fromPicker" #FromDate="ngModel" name="FromDate"
                                        [(ngModel)]="HotelRate.FromDate" required>
                                    <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #fromPicker></mat-datepicker>
                                    @if ((FromDate.dirty || FromDate.touched) || (FromDate.invalid && isSubmitted)) {
                                    <mat-error>From Date is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <!-- To Date -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>To Date</mat-label>
                                    <input matInput [matDatepicker]="toPicker" #ToDate="ngModel" name="ToDate"
                                        [(ngModel)]="HotelRate.ToDate" required [min]="HotelRate.FromDate">
                                    <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #toPicker></mat-datepicker>
                                    @if ((ToDate.dirty || ToDate.touched) || (ToDate.invalid && isSubmitted)) {
                                    <mat-error>To Date is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <!-- CP Rate -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>CP Rate</mat-label>
                                    <input matInput #CpRate="ngModel" name="CpRate" [(ngModel)]="HotelRate.CpRate"
                                        type="number" required>
                                    @if ((CpRate.dirty || CpRate.touched) || (CpRate.invalid && isSubmitted)) {
                                    <mat-error>CP Rate is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <!-- MAP Rate -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>MAP Rate</mat-label>
                                    <input matInput #MapRate="ngModel" name="MapRate" [(ngModel)]="HotelRate.MapRate"
                                        type="number" required>
                                    @if ((MapRate.dirty || MapRate.touched) || (MapRate.invalid && isSubmitted)) {
                                    <mat-error>MAP Rate is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <!-- AP Rate -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>AP Rate</mat-label>
                                    <input matInput #ApRate="ngModel" name="ApRate" [(ngModel)]="HotelRate.ApRate"
                                        type="number" required>
                                    @if ((ApRate.dirty || ApRate.touched) || (ApRate.invalid && isSubmitted)) {
                                    <mat-error>AP Rate is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <!-- Status -->
                                <mat-form-field appearance="outline" class="col-sm-2">
                                    <mat-label>Status</mat-label>
                                    <mat-select #Status="ngModel" name="Status" [(ngModel)]="HotelRate.Status" required>
                                        @for (status of StatusList; track status.Key) {
                                        <mat-option [value]="status.Key">{{ status.Value }}</mat-option>
                                        }
                                    </mat-select>
                                    @if ((Status.dirty || Status.touched) ||
                                    (Status.invalid && isSubmitted)) {
                                    <mat-error>Status is <strong>required</strong></mat-error>
                                    }
                                </mat-form-field>

                                <!-- Add / Update Button -->
                                <div class="col-sm-2 d-flex mb-4 align-items-center gap-2">
                                    <button mat-raised-button color="primary" (click)="addToTable()">
                                        <i class="bx bx-plus me-1"></i>
                                        {{ editingRowIndex !== null ? 'Update' : 'Add' }}
                                    </button>
                                    @if (editingRowIndex !== null) {
                                    <button mat-raised-button color="warn" class="ms-2" (click)="cancelEdit()">
                                        Cancel
                                    </button>
                                    }
                                </div>

                                <hr>

                                <!-- Preview Table -->
                                <div class="col-sm-12">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-sm nowrap w-100">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Hotel</th>
                                                    <th>Category</th>
                                                    <th>Room Type</th>
                                                    <th>From Date</th>
                                                    <th>To Date</th>
                                                    <th>CP Rate</th>
                                                    <th>MAP Rate</th>
                                                    <th>AP Rate</th>
                                                    <th>Edit</th>
                                                    <th>Status</th>
                                                    <th>Remove</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (row of HotelRateRows(); track $index; let i = $index) {
                                                <tr>
                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{ row.HotelName }}</td>
                                                    <td>{{ row.HotelCategoryName }}</td>
                                                    <td>{{ row.RoomTypeName }}</td>
                                                    <td>{{ row.FromDate | date:'dd-MM-yyyy' }}</td>
                                                    <td>{{ row.ToDate | date:'dd-MM-yyyy' }}</td>
                                                    <td>{{ row.CpRate }}</td>
                                                    <td>{{ row.MapRate }}</td>
                                                    <td>{{ row.ApRate }}</td>
                                                    <td>
                                                        <a class="text-success" style="cursor:pointer"
                                                            (click)="editRow(i)">
                                                            <i class="bx bxs-edit-alt"></i>
                                                        </a>
                                                    </td>
                                                    <td>{{ AllStatusList[row.Status] }}</td>

                                                    <td>
                                                        <a class="text-danger" style="cursor:pointer"
                                                            (click)="removeRow(i)">
                                                            <i class="bx bxs-trash"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                                }
                                                @if (HotelRateRows().length === 0) {
                                                <tr>
                                                    <td colspan="11" class="text-center text-muted">
                                                        No rates added yet
                                                    </td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Save All Button -->
                                @if (HotelRateRows().length > 0) {
                                <div class="col-sm-12 mt-3">
                                    <button mat-raised-button color="primary" (click)="saveHotelRates()">
                                        <i class="bx bx-save me-1"></i> Save All
                                    </button>
                                </div>
                                }

                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>